import '../../assets/index21.css';var h = Object.defineProperty, w = Object.defineProperties;
var y = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
var T = (e, i, t) => i in e ? h(e, i, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[i] = t, p = (e, i) => {
  for (var t in i || (i = {}))
    d.call(i, t) && T(e, t, i[t]);
  if (o)
    for (var t of o(i))
      g.call(i, t) && T(e, t, i[t]);
  return e;
}, u = (e, i) => w(e, y(i));
var c = (e, i) => {
  var t = {};
  for (var a in e)
    d.call(e, a) && i.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && o)
    for (var a of o(e))
      i.indexOf(a) < 0 && g.call(e, a) && (t[a] = e[a]);
  return t;
};
import { jsxs as P, jsx as n } from "react/jsx-runtime";
import { forwardRef as I, useEffect as R, useState as S } from "react";
import { usePageTitle as z } from "./hooks/usePageTitle.js";
import { useTruncated as B } from "./hooks/useTruncated.js";
import { T as E } from "../../Title-D2uPkT4U.js";
const F = "PageTitle-module__pageTitle___zn8Ty", M = "PageTitle-module__titleText___7x-le", Q = "PageTitle-module__imageContainer___MwtVC", V = "PageTitle-module__titlePrefix___vFjWQ", r = {
  pageTitle: F,
  titleText: M,
  imageContainer: Q,
  titlePrefix: V
}, K = I((W, C) => {
  var _ = W, {
    accentedText: e,
    browserTitle: i,
    children: t,
    dataPlumId: a,
    image: s,
    isTruncatedCallback: m
  } = _, x = c(_, [
    "accentedText",
    "browserTitle",
    "children",
    "dataPlumId",
    "image",
    "isTruncatedCallback"
  ]);
  const { pageTitle: N, setPageTitle: f } = z(t);
  R(() => {
    f(i || `${e ? `${e} ` : ""}${t}`);
  }, [t, N, f]);
  const [j, v] = S(!1), { ref: $, isTruncated: l } = B(C);
  return l !== j && (m && m(l), v(l)), /* @__PURE__ */ P(
    "div",
    {
      className: r.pageTitle,
      "data-has-image": !!s,
      children: [
        s && /* @__PURE__ */ n("div", { className: r.imageContainer, children: typeof s == "string" ? /* @__PURE__ */ n("img", { alt: "", src: s }) : s() }),
        /* @__PURE__ */ P(
          E,
          u(p({
            className: r.titleText,
            "data-plum-id": a,
            id: "page-title",
            order: 1,
            ref: $
          }, x), {
            children: [
              e && /* @__PURE__ */ n("span", { className: r.titlePrefix, children: e }),
              t
            ]
          })
        )
      ]
    }
  );
});
export {
  K as PageTitle
};
